import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { xingConnect, LOGIN_STATE } from '@xingternal/xing-frame-provider';
import { withFlavourCSS } from '@xingternal/flavour';

import trackings from '../trackings';
import { withTracking } from '../xing-tracking';
import Logo from '../Logo';
import LISubHeader from './LoggedInSubHeader';
import LOSubHeader from './LoggedOutSubHeader';

import { base, odl, xdl } from './flavours';

const Header = ({
  activeItem,
  features,
  featureSwitches,
  hasActiveSearchBar,
  hasCTA,
  helpLink,
  hideButtons,
  homeLink,
  isStatic,
  loginLink,
  loginState,
  notifications,
  signupLink,
  styles,
  type,
  user,
  whiteBG,
  ...props
}) => {
  return (
    <div className={styles.headerPlacebo}>
      <div
        className={classNames(styles.headerWrapper, {
          [styles.hasActiveSearchBar]: hasActiveSearchBar,
          [styles.premiumHeaderWrapper]: features && features.isPremium,
          [styles.headerStatic]: isStatic,
          [styles.headerWrapperWhite]: whiteBG,
        })}
      >
        <header
          className={classNames(styles.header, {
            [styles[`${type}Header`]]: Boolean(styles[`${type}Header`]),
          })}
        >
          <div className={styles.logoWrapper}>
            <Logo className={styles.logo} homeLink={homeLink} />
          </div>

          {loginState === LOGIN_STATE.loggedOut ? (
            !hideButtons && (
              <LOSubHeader
                {...{
                  hasCTA,
                  loginLink,
                  signupLink,
                  whiteBG,
                  styles,
                  ...props,
                }}
              />
            )
          ) : (
            <LISubHeader
              {...{
                helpLink,
                notifications,
                hasActiveSearchBar,
                activeItem,
                styles,
                user,
                featureSwitches,
                ...props,
              }}
            />
          )}
        </header>
      </div>
    </div>
  );
};

Header.displayName = 'Header';

Header.defaultProps = {
  type: 'standard',
  notifications: {},
};

Header.propTypes = {
  helpLink: PropTypes.string,
  homeLink: PropTypes.string,
  type: PropTypes.string,
  isStatic: PropTypes.bool,
  notifications: PropTypes.object,
  loginState: PropTypes.oneOf(Object.values(LOGIN_STATE)).isRequired,
  hasCTA: PropTypes.bool,
  loginLink: PropTypes.string,
  signupLink: PropTypes.string,
  whiteBG: PropTypes.bool,
  hideButtons: PropTypes.bool,
  activeItem: PropTypes.string,
  styles: PropTypes.object.isRequired,
  hasActiveSearchBar: PropTypes.bool.isRequired,
  features: PropTypes.object,
  user: PropTypes.object,
  featureSwitches: PropTypes.array.isRequired,
};

export { Header };
export default xingConnect()(
  withFlavourCSS(base, { odl, xdl })(withTracking(trackings)(Header))
);
